import { selector } from 'lib/selectors';
import { companyFeatureSetLoadedSelector } from 'domain/companies';
import { bankFeedUserPermissionsLoadedSelector } from 'domain/bankFeed';
import { hasLoadedERPSettingSelector, isErpConnectedSelector } from 'domain/settings';

export const waitDashboardRouteLoadedSelector = selector(
  companyFeatureSetLoadedSelector,
  (isLoaded: boolean) => isLoaded,
);
export const waitCompanySettingsRouteLoadedSelector = selector(
  companyFeatureSetLoadedSelector,
  (isLoaded: boolean) => isLoaded,
);
export const waitBankFeedRouteLoadedSelector = selector(
  bankFeedUserPermissionsLoadedSelector,
  (isLoaded: boolean) => isLoaded,
);

export const waitCompanyIntegrationRouteLoadedSelector = selector(
  hasLoadedERPSettingSelector,
  isErpConnectedSelector,
  (isLoaded: boolean, isErpConnected: boolean) => (isErpConnected ? isLoaded : true),
);
